module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    ref: "input",
    domProps: {
      "value": _vm.value,
      "value": (_vm.val)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }, function($event) {
        _vm.updateValue($event.target.value)
      }],
      "blur": function($event) {
        _vm.handleChange($event.target.value)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-265f175c"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/component/number-input/number-input.vue
// module id = 8
// module chunks = 0